var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQueue = function SvgIconQueue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zM3.75 11a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM2.75 18a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.03 10.402a1 1 0 0 0-1.53.848v7.5a1 1 0 0 0 1.53.848l6-3.75a1 1 0 0 0 0-1.696zM20.613 15 17.5 16.946v-3.892z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconQueue;